(function ($) {
	/* add/remove focus class for the form inputs */
	$(".contact-us-form input, .contact-us-form textarea, .gravity-all-md input:not([type='radio']), .gravity-all-md textarea")
		.on("focus", function() {
			$(this).closest("li").addClass("in-focus")
		})
		.on("blur", function() {
			if( $(this).val() === "") {
				$(this).closest("li").removeClass("in-focus");
			}
		})
})(jQuery);
